/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { SvgIcon } from '@mui/material';

export function SuccessIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props}>
      <path d="M23,12 L20.56,9.21 L20.9,5.52 L17.29,4.7 L15.4,1.5 L12,2.96 L8.6,1.5 L6.71,4.69 L3.1,5.5 L3.44,9.2 L1,12 L3.44,14.79 L3.1,18.49 L6.71,19.31 L8.6,22.5 L12,21.03 L15.4,22.49 L17.29,19.3 L20.9,18.48 L20.56,14.79 L23,12 Z M9.38,16.01 L7,13.61 C6.61,13.22 6.61,12.59 7,12.2 L7.07,12.13 C7.46,11.74 8.1,11.74 8.49,12.13 L10.1,13.75 L15.25,8.59 C15.64,8.2 16.28,8.2 16.67,8.59 L16.74,8.66 C17.13,9.05 17.13,9.68 16.74,10.07 L10.82,16.01 C10.41,16.4 9.78,16.4 9.38,16.01 Z" />
    </SvgIcon>
  );
}
